import styled, { css } from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { COLORS } from 'modules/core/theme/colors';
import { Tooltip } from 'react-tooltip';

export const DROPDOWN_ARROW_STYLES = `
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  position: absolute;
  right: 0.5em;
  top: 50% !important;
  transform: translateY(-50%);
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  color: black;
`;

export const TOOLTIP_STYLES = css`
  z-index: 999;
  opacity: 1 !important;
  padding: 4px 6px !important;
  font-size: 12px !important;
  line-height: 16px !important;
  border-radius: 4px !important;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15) !important;
  font-weight: ${({ theme: { boldText } }) => boldText.medium} !important;
  font-family: ${({ theme: { fontFamily } }) => fontFamily.primary} !important;
`;

export const DefaultTooltip = styled(Tooltip)`
  ${TOOLTIP_STYLES}

  background-color: ${COLORS.WHITE} !important;
  color: ${COLORS.BLACK} !important;

  &.react-tooltip-arrow {
    color: ${COLORS.WHITE} !important;
  }
`;

export const PrintContainer = styled.div`
  width: 100%;
  margin-left: 2px;
`;

export const FormRow = styled(Row)`
  align-items: center;
  margin-bottom: 10px;
`;

export const ColUI = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin: 2px auto;
  & > div {
    height: auto;
  }
`;

export const ExtraCashUnavailableWarn = styled.div`
  font-size: 12px;
  width: 450px;
  margin-right: 0;
  margin-top: 12px;
  text-align: justify;
  color: ${COLORS.RED_4};
`;
